import { type FC } from 'react'
import classNames from 'classnames'
import { Image } from '~/components/Image/Image'
import { type BusinessCardProps } from './BusinessCard.interface'
import styles from './BusinessCard.module.scss'
import { Tag } from '~/components/Tag/Tag'

export const BusinessCard: FC<BusinessCardProps> = ({
  id,
  index,
  title,
  description,
  url,
  image,
  type,
  categories,
  // imageLazy,
  priorityImage,
  active,
  hovered,
  setBusinessId,
  setHoveredBusinessId
}) => {
  const cardTitle = `${index}. ${title}`
  const reducedCategories = categories?.slice(0, 3) ?? []

  return (
    <div
      className={classNames(
        styles.container,
        active && styles['is-active'],
        hovered && styles['is-hovered']
      )}
      role="button"
      tabIndex={0}
      onMouseEnter={() => { setHoveredBusinessId?.(id) }}
      onMouseLeave={() => { setHoveredBusinessId?.(null) }}
      onClick={() => { setBusinessId && setBusinessId(id) }}
      onKeyDown={() => {}}

    >
      {image?.src && (
      <div className={styles['image-container']}>
        <Image
          className={styles.img}
          src={image.src}
          alt={image.alt ?? ''}
          width={161}
          height={115}
          loading="eager"
          // loading={imageLazy ? 'lazy' : 'eager'}
          priority={priorityImage}
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP08DhZDwAEEwHarcD1UgAAAABJRU5ErkJggg=="
          placeholder="blur"
        />
      </div>
      )}
      <div className={styles.content}>
        <h2 className={styles.title}>
          <a onClick={(e) => { e.preventDefault() }} href={url}>{cardTitle}</a>
        </h2>
        { description && <p className={styles.description}>{description}</p> }
        <ul className={styles.tags}>
          {type && (
            <li>
              <Tag value={type.value} small variant="secondary">
                {type.name}
              </Tag>
            </li>
          )}

          {reducedCategories.slice(0, 2).map((category, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${id}-${idx}`}>
              <Tag small variant="secondary">{category.name}</Tag>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
